import { FC } from 'react';

import { NbPageHeader } from '@/components/Neobrut';

export const PrivacyPolicy: FC = () => {
  return (
    <div className="mx-auto w-full max-w-2xl lg:max-w-3xl pb-10">
      <NbPageHeader
        slug="/ política de privacidad"
        title={<>Política de<br />privacidad.</>}
        tone="plain"
      />
      <ol className="flex list-decimal flex-col gap-4 px-8 pt-4 text-justify text-[14px] leading-relaxed">
        <li>
          <div className="font-bold">Introducción</div>
          <p>
            En RescatApp nos comprometemos a proteger la privacidad de nuestros usuarios y a
            garantizar que sus datos personales sean tratados de manera segura y responsable. Esta
            Política de Privacidad explica cómo recopilamos, usamos y protegemos la información
            personal de los usuarios de nuestra plataforma.
          </p>
          <p>
            Al acceder y/o utilizar RescatApp, usted <b>acepta</b> los términos de esta Política de
            Privacidad. Si no está de acuerdo con nuestra política, le solicitamos que no utilice
            nuestros servicios.
          </p>
        </li>

        <li>
          <div>
            <div className="font-bold">Información que Recopilamos</div>
            <p>Recopilamos dos tipos de información de nuestros usuarios:</p>
            <ul className="list-inside list-disc pt-2">
              <li>
                <strong>Información Personal:</strong> Incluye datos como nombre, dirección de
                correo electrónico, número de teléfono, y cualquier otra información que usted
                decida proporcionar al registrarse o interactuar con nuestra plataforma.
              </li>
              <li>
                <strong>Información No Personal:</strong> Incluye datos sobre el uso de la
                plataforma, como el tipo de dispositivo, la dirección IP, el navegador utilizado y
                las páginas visitadas dentro de la aplicación. Esta información se recopila
                automáticamente a través de cookies y tecnologías similares.
              </li>
            </ul>
          </div>
        </li>

        <li>
          <div>
            <div className="font-bold">Uso de la Información</div>
            <p>La información que recopilamos se utiliza para los siguientes fines:</p>
            <ul className="list-inside list-disc pt-2">
              <li>Permitir a los usuarios registrarse y crear publicaciones en RescatApp.</li>
              <li>Mejorar y personalizar la experiencia del usuario.</li>
              <li>Gestionar y resolver solicitudes o consultas enviadas por los usuarios.</li>
              <li>
                Enviar actualizaciones y notificaciones relacionadas con el funcionamiento de la
                plataforma.
              </li>
              <li>Analizar el uso de la aplicación para mejorar el servicio.</li>
            </ul>
          </div>
        </li>

        <li>
          <div>
            <div className="font-bold">Protección de la Información</div>
            <p>
              Implementamos medidas razonables de seguridad técnicas, administrativas y físicas para
              proteger los datos personales frente a pérdida, acceso no autorizado, alteración o
              divulgación. No obstante, debido a la naturaleza de Internet, <b>no</b> podemos
              garantizar una seguridad absoluta.
            </p>
          </div>
        </li>

        <li>
          <div>
            <div className="font-bold">Compartir Información con Terceros</div>
            <p>
              RescatApp no compartirá, venderá ni alquilará su información personal a terceros sin
              su consentimiento, salvo en los siguientes casos:
            </p>
            <ul>
              <li>
                Cuando sea necesario para cumplir con las leyes, regulaciones o procesos legales
                aplicables.
              </li>
              <li>
                Cuando sea necesario para proteger los derechos, la propiedad o la seguridad de
                RescatApp, sus usuarios o el público.
              </li>
              <li>
                Con proveedores de servicios que nos ayuden a operar la plataforma, siempre y cuando
                esos proveedores respeten estándares de privacidad adecuados.
              </li>
            </ul>
          </div>
        </li>

        <li>
          <div>
            <div className="font-bold">Cookies y Tecnologías Similares</div>
            <p>
              Utilizamos cookies y tecnologías similares para mejorar la experiencia del usuario y
              analizar cómo se utiliza la plataforma. Las cookies son pequeños archivos de texto que
              se almacenan en su dispositivo. Puede ajustar la configuración de su navegador para
              rechazar las cookies, pero esto podría afectar el funcionamiento de algunos servicios
              de la plataforma.
            </p>
          </div>
        </li>

        <li>
          <div>
            <div className="font-bold">Sus Derechos sobre la Información</div>
            <p>Como usuario de RescatApp, tiene derecho a:</p>
            <ul className="list-inside list-disc pt-2">
              <li>
                Acceder, corregir o eliminar la información personal que hemos recopilado sobre
                usted.
              </li>
              <li>Solicitar la restricción del uso de sus datos personales.</li>
              <li>
                Retirar su consentimiento para el uso de sus datos personales en cualquier momento
                (sin que ello afecte la legalidad del tratamiento previo).
              </li>
              <li>Presentar una queja ante la autoridad de protección de datos correspondiente.</li>
            </ul>
          </div>
        </li>

        <li>
          <div>
            <div className="font-bold">Modificaciones a la Política de Privacidad</div>
            <p>
              RescatApp se reserva el derecho de modificar esta Política de Privacidad en cualquier
              momento. Cualquier cambio será publicado en esta página y entrará en vigencia al ser
              actualizado. Le recomendamos revisar periódicamente esta sección para mantenerse
              informado sobre cómo protegemos su información.
            </p>
          </div>
        </li>

        <li>
          <div>
            <div className="font-bold">Contacto</div>
            <p>
              Si tiene preguntas o inquietudes sobre esta Política de Privacidad o sobre cómo
              gestionamos su información personal, puede ponerse en contacto con nosotros a través
              de: contacto@rescatapp.com.ar
            </p>
          </div>
        </li>
      </ol>
    </div>
  );
};
